import { useCallback } from 'react';

import { makeStyles } from 'e100-react-components';

import { Map } from 'common/utils/Map/types/map';

type Position = [number, number];
interface Options {
  content?: any;
}

export const useStyles = makeStyles(({ shape }) => ({
  popupContainer: ({ isShowClose }: { isShowClose: boolean }) => ({
    top: '-44px',
    '& > div:first-child': {
      transform: 'translateX(-50%)',
      left: '50%',
      right: 'inherit !important',
      marginRight: 'inherit !important',
      borderRadius: shape.borderRadius,
      boxShadow: '0px 5px 6px 0px #6372820A, 0px 3px 16px 0px #6372821A, 0px 9px 12px 0px #6372821F',

      '& > div:first-child svg': {
        display: `${isShowClose ? 'block' : 'none'}`,
      },
      '& > div:nth-child(2)': {
        margin: '8px;',
      },
    },
  }),
}));

export const useHereInfoWindow = (map: Map | null, showCloseIcon: boolean = false, onClose?: () => void) => {
  const classes = useStyles({ isShowClose: showCloseIcon });

  const hereInfoWindow = useCallback(
    (coordinates: Position, infoWindowRef: HTMLDivElement | null) => {
      if (coordinates && infoWindowRef && map && map.mapUi) {
        class HerePopup extends window.H.ui.InfoBubble {
          constructor(position: Position, options: Options) {
            super(
              {
                lat: position[0],
                lng: position[1],
              },
              options
            );
          }

          hide() {
            if (map) {
              map.mapUi.removeBubble(this);
            }
          }
        }

        const herePopup = new HerePopup(coordinates, {
          content: infoWindowRef,
        });

        //@ts-ignore
        herePopup.addEventListener('statechange', function(evt) {
        if (evt.target.getState() === H.ui.InfoBubble.State.CLOSED && onClose) {
          onClose()
        }
    })

        herePopup.addClass(classes.popupContainer);

        map.mapUi.addBubble(herePopup);

        return herePopup;
      }
    },
    [map, classes, onClose]
  );

  return hereInfoWindow;
};
